module.exports = __webpack_public_path__ + "img/main-contest-bg.e4896ac2.png";